import styled from 'styled-components';

const StyledNotificationsScroll = styled.div`
  max-height: 275px;
  flex: 0 100%;
  overflow: scroll;

  @media (max-width: 414px) {
    max-height: 275px;
  }
  @media (max-width: 407px) {
    max-height: 290px;
  }
  @media (max-width: 375px) {
    max-height: 310px;
  }
  @media (max-width: 320px) {
    max-height: 335px;
  }
`;

export {
  StyledNotificationsScroll,
};
